
import { Component, Ref, Vue, Watch } from 'vue-property-decorator'
import { Observer } from 'mobx-vue'
import Teleport from '@xt/client/mixins/components/teleport.vue'
import lodash from 'lodash'
import Navbar from './components/Navbar/index.vue'
import CourseMap from './components/CourseMap/index.vue'
import WaterfallTab from './components/WaterfallTab/index.vue'
import GuidePopup from './components/Entrance/GuidePopup.vue'
import JoinClassPopup from '@xt/www/components/joinClassPopup/index.vue'
import FinalStep from './components/FinalStep/index.vue'
import StudyReview from './components/StudyReview/index.vue'
import PopLayout from '../../../components/classhour/layout/index.vue'
import ContentEditor from '../../../components/classhour/editor/index.vue'
import ClasshourDetail from '@xt/www/components/classhour/detail/index.vue'
import CourseInfoModal from './components/CourseInfoModal/index.vue'
import { courseBan } from '@xt/client/utils/course/ban'
import { driver, type DriveStep, Config } from 'driver.js'
import type { Classhour } from '@xt/client/utils/classhour-map/types.d'
import type { WaterfallMoment } from '@xt/client/entities/course-v2/types.d'
import type { StudyReviewDataSource, StudyReviewResult } from '@xt/client/types/course'
import { $service } from '@xt/client/experimental/request/service'
import { EnumApiCourse } from '@xt/client/api'
import { AjaxBasics } from '@xt/client/helpers/ajaxBasics'
import moment from 'moment'
import StudySummary from './components/StudySummary/index.vue'
import SumReviewPopStorage from '@xt/client/utils/summary/index'
import StudySummaryTip from './components/StudySummaryTip/index.vue'
import { EnumGuideStep } from '@xt/client/entities/course-v2/guide'

let driverObj: any = null

const elVisible = {
  el1: false,
  el2: false
}

@Observer
@Component({
  layout: 'clean',
  components: {
    Navbar,
    CourseMap,
    WaterfallTab,
    ClasshourDetail,
    PopLayout,
    ContentEditor,
    GuidePopup,
    JoinClassPopup,
    FinalStep,
    CourseInfoModal,
    StudyReview,
    StudySummary,
    Teleport,
    StudySummaryTip
  },
  async fetch(ctx) {
    const hasOwn = await ctx.store.$courseV2.initPageData(ctx.params.id)

    if (!hasOwn) {
      ctx.redirect('/')
    }
  },
  validate({ params }) {
    return /^\d+$/.test(params.id)
  }
})
export default class CourseDetail extends Vue {
  showCourseInfoModal = false
  hideCourseIntroductionTab: boolean = false

  showBackToTop: boolean = false
  ob: IntersectionObserver | null = null
  currentTime = AjaxBasics.serviceDate.utcOffset(+8).valueOf()

  @Ref()
  studyReview: {
    showReview(data: StudyReviewDataSource): void
  }

  @Ref()
  editor?: {
    getFormStatus(): { hasImage: boolean; hasContent: boolean; hasTitle: boolean }
  }

  @Ref()
  popLayout: {
    open: () => void
    hide: () => void
  }

  // 判断是否已结课
  get isLearnEnd() {
    // 此处兼容全阶课情况
    return moment(this.CourseInfo?.fullLearnEndTime ? this.CourseInfo.fullLearnEndTime : this.CourseInfo?.learnEndTime).isBefore(
      this.currentTime
    )
  }

  get productId() {
    return this.$store.$courseV2.productInfo?.id as unknown as string
  }

  get CourseInfo() {
    return this.$store.$courseV2.courseInfo
  }

  get GuideData() {
    return this.$store.$courseV2.GuideData
  }
  get courseId() {
    return this.$route.params['id'] as string
  }

  dairyOptions = {
    type: 'dairy',
    showBackButton: false,
    contentRequired: false,
    imageRequired: true,
    maxImageSize: 9,
    editorTitle: '日常内容',
    uploaderTitle: '添加图片',
    contentPlaceholder: '在这里，可以聊聊日常练习，分享学习感悟，或是讲讲其他趣事。',
    courseId: this.$route.params['id'] as string
  }

  // 开课前准备弹窗显隐
  visibleGuide: boolean = false
  // 加群弹窗显隐
  visibleJoinClass: boolean = false
  // 最终页显隐藏
  visibleFinal: boolean = false

  // 第二入口图标显示
  showSecondEntrance: boolean = false
  // 直播间第二入口图标显示
  showLiveEntrance: boolean = false

  visibleStudy: boolean = false

  visibleStudySummaryTip: boolean = false

  // 学习小结弹窗提示
  handleStudySummaryTip() {
    this.showStudySummaryTip(false)

    this.$nextTick(() => {
      this.showStudySummary(true)
    })
  }
  checkShowSummaryReview() {
    // 三个状态条件 - 课程id，用户id，是否开启学习回顾
    if (this.$store.$courseV2.mapInfo?.showReview === true) {
      const userId = this.$store.$storeUser.UserInfo?.id

      if (!userId || !this.courseId) return

      if (!SumReviewPopStorage.getReviewStatusByKey({ courseId: this.courseId, userId })) {
        this.showStudySummaryTip(true)
      }
    }
  }
  showStudySummaryTip(isShow: boolean) {
    this.visibleStudySummaryTip = isShow

    const userId = this.$store.$storeUser.UserInfo?.id
    if (isShow === false && this.courseId && userId) {
      // 将数据写入缓存
      SumReviewPopStorage.setReviewStatusByKey({
        userId,
        courseId: this.courseId
      })
    }
  }

  showStudySummary(isShow: boolean) {
    this.visibleStudy = isShow
  }

  showGuidePop(isShow: boolean) {
    this.visibleGuide = isShow
    // 切换之后的还原操作,在动画完成以后执行
    if ((this.$refs['guide'] as any).current === 1) {
      setTimeout(() => {
        ;(this.$refs['guide'] as any).current = 0
      }, 300)
    }
  }
  showJoinClassPop(isShow: boolean) {
    this.visibleJoinClass = isShow
  }

  showFinalStepPop(isShow: boolean) {
    this.visibleFinal = isShow
  }

  handleLiveEntrance() {
    // 跳转直播间-携带courseId参数
    this.$router.push({
      path: `/guide/live?courseId=${this.courseId}`
    })
  }

  handleSencodEntrance() {
    const data = this.GuideData.getStageOneData()
    ;(this.$refs['detail'] as any).showMockPop(data.classhourDetail)
    setTimeout(() => {
      this.onDriveNext()
    }, 400)
  }

  isMoving: boolean = false
  // 防止点击过快
  onDriveNext() {
    driverObj.moveNext()
    this.isMoving = false
  }
  onDrivePrev() {
    driverObj.movePrevious()
    this.isMoving = false
  }

  // 第一阶段开始执行guide
  onStartOneDrive() {
    // 关闭入口弹窗
    this.showGuidePop(false)
    // 初始化时，往瀑布流塞入一条数据
    const data = this.GuideData.getStageOneData()
    data.homeworkCard && this.$store.$courseV2.CourseWaterfall.unshiftMomentItemToTab('find', data.homeworkCard)

    const config: Config = {
      popoverClass: 'custom-popover-class',
      prevBtnText: '上一步',
      nextBtnText: '下一步',
      doneBtnText: '结束',
      showProgress: true,
      steps: this.GuideData.dataStepOne,
      showButtons: ['previous', 'next'],
      onNextClick: (el, step, options) => {
        if (this.isMoving) return
        this.isMoving = true

        const steps = options.state.activeIndex! + 1

        // 第一阶段结束操作
        if (steps === this.GuideData.dataStepOne.length) {
          this.$store.$courseV2.CourseWaterfall.removeFirstItem('find')
          this.$router.replace({
            path: `/guide/live?courseId=${this.courseId}`,
            replace: true
          })
          return
        }

        // 第二阶段的时间变化
        if (steps === 13) {
          this.GuideData.setLiveTimeChange()
        }

        // 第二阶段的课时详情弹窗
        if (steps === 10) {
          const data = this.GuideData.getStageOneData()
          ;(this.$refs['detail'] as any).showMockPop(data.classhourDetail)
          setTimeout(() => {
            this.onDriveNext()
          }, 400)
          return
        }

        if (steps === 9) {
          // 日记蒙层处理
          const pDom: any = document.getElementsByClassName('driver-overlay')[0].childNodes[0]
          pDom.classList.remove('hide-mask')
          ;(this.$refs['waterfallRef'] as any).hideDairyPop()

          // 进入到第十步时滚动到顶部
          window.scrollTo({
            top: 0,
            behavior: 'smooth'
          })
        }

        // 第一阶段的日记弹窗
        if (steps === 8) {
          // 日记蒙层处理
          const pDom: any = document.getElementsByClassName('driver-overlay')[0].childNodes[0]
          pDom.classList.add('hide-mask')

          // 拉起作业日记详情弹窗
          ;(this.$refs['waterfallRef'] as any).showMockDairyPop(this.GuideData.stageOneData)

          //TODO 拉起作业日记详情弹窗dom获取待稳定
          setTimeout(() => {
            this.onDriveNext()
          }, 400)
          return
        }

        // 在瀑布流展示之前，给瀑布流第一条数据打上高亮标记
        if (steps === 3) {
          const c = document.getElementsByClassName('content-card')[0]
          c && c.setAttribute('id', 'stage_one_7v2')
        }

        this.onDriveNext()
      },
      onPrevClick: (el, step, options) => {
        if (this.isMoving) return
        this.isMoving = true

        const steps = options.state.activeIndex! + 1
        // 第二阶段的课时详情弹窗回跳操作
        if (steps === 11) {
          ;(this.$refs['detail'] as any).hidePop()
        }

        // 第一阶段的最后一步回跳
        if (steps === 10) {
          // 日记蒙层处理
          const pDom: any = document.getElementsByClassName('driver-overlay')[0].childNodes[0]
          pDom.classList.add('hide-mask')
          // 拉起作业日记详情弹窗
          ;(this.$refs['waterfallRef'] as any).showMockDairyPop(this.GuideData.stageOneData)
          setTimeout(() => {
            this.onDrivePrev()
          }, 400)
          return
        }

        // 第一阶段的日记弹窗
        if (steps === 9) {
          // 日记蒙层处理
          const pDom: any = document.getElementsByClassName('driver-overlay')[0].childNodes[0]
          pDom.classList.remove('hide-mask')
          ;(this.$refs['waterfallRef'] as any).hideDairyPop()
        }
        this.onDrivePrev()
      },
      onHighlighted: (el, step, options) => {
        const steps = options.state.activeIndex! + 1
        // console.log(steps + '渲染完成')

        if (steps === 14) {
          this.showLiveEntrance = true
        }
        if (steps === 13) {
          this.showLiveEntrance = false
        }
        if (steps === 11) {
          this.showSecondEntrance = false
        }
        if (steps === 10) {
          this.showSecondEntrance = true
        }
        if (steps === 9) {
          this.showSecondEntrance = false
        }
        return
      },
      onDestroyStarted: (el, step, options) => {
        const steps = options.state.activeIndex! + 1

        // 蒙层点击操作
        this.$confirmV2({
          desc: '确认要关闭指引吗？',
          onOk: () => {
            // 关闭课时详情弹窗
            if (steps >= 11) {
              ;(this.$refs['detail'] as any).hidePop()
            }
            // 关闭日记弹窗
            if (steps === 9) {
              ;(this.$refs['waterfallRef'] as any).hideDairyPop()
            }
            driverObj.destroy()
            this.GuideData.setGuideStatus(false)
            this.$store.$courseV2.CourseWaterfall.removeFirstItem('find')
          }
        })
      },
      onHighlightStarted: (el, step, options) => {
        const steps = options.state.activeIndex! + 1

        if (!el) return

        // 兼容第一阶段材料区高亮滚动拉起侧边白块问题
        if (steps === 9) {
          const originalScrollIntoView = el.scrollIntoView

          el.scrollIntoView = (option: any) => {
            option.block = 'end'

            originalScrollIntoView.call(el, option)
          }
        }

        // 处理drive第一阶段拉取文房内容，材料内容时出现白块
        if (steps === 12 || steps === 13) {
          const originalScrollIntoView = el.scrollIntoView

          el.scrollIntoView = (option: any) => {
            option.inline = 'end'

            originalScrollIntoView.call(el, option)
          }
        }
      }
    }

    driverObj = driver(config)
    driverObj.drive()
    this.GuideData.setStage(EnumGuideStep.One)
    // 设置状态
    this.GuideData.setGuideStatus(true)
  }

  // 第三阶段开始执行guide
  onStartThreeDrive() {
    const config: Config = {
      popoverClass: 'custom-popover-class',
      prevBtnText: '上一步',
      nextBtnText: '下一步',
      doneBtnText: '结束',
      showProgress: true,
      steps: this.GuideData.dataStepThree,
      showButtons: ['previous', 'next'],
      onNextClick: (el, step, options) => {
        if (this.isMoving) return
        this.isMoving = true

        // 未切换前的当前步序
        const steps = options.state.activeIndex! + 1

        // 第三阶段切换提交作业
        if (steps === 2) {
          const data = this.GuideData.getThreeData()
          ;(this.$refs['detail'] as any).handleMockToggleNext(data.homeworkSubmit)
          setTimeout(() => {
            this.onDriveNext()
          }, 400) // detail组件切换有动画时间差，需要等待一下
          return
        }

        // 第三阶段 - 第五步
        if (steps === 4) {
          ;(this.$refs['detail'] as any).handleTogglePre()
          const data = this.GuideData.getWaitReviewedThreeData()
          ;(this.$refs['detail'] as any).classhourDetail = data.classhourDetail
          setTimeout(() => {
            this.onDriveNext()
          }, 400)
          return
        }

        // 第三阶段 - 第七步
        if (steps === 6) {
          const data = this.GuideData.getThreeData({
            selfId: this.$store.$storeUser.UserInfo.id
          })
          ;(this.$refs['detail'] as any).handleMockToggleNext(data.homeworkContent)
          this.GuideData.setShowContentMenu(true)
          setTimeout(() => {
            this.onDriveNext()
          }, 400)
          return
        }

        // 第三阶段切换回主功能区
        if (steps === 7) {
          ;(this.$refs['detail'] as any).handleTogglePre()
          const data = this.GuideData.getUpdateHomeworkThreeData()
          ;(this.$refs['detail'] as any).classhourDetail = data.classhourDetail
          setTimeout(() => {
            this.onDriveNext()
          }, 400)
          return
        }

        this.onDriveNext()
      },
      onPrevClick: (el, step, options) => {
        if (this.isMoving) return
        this.isMoving = true

        const steps = options.state.activeIndex! + 1

        // 第三阶段切换提交作业-第三步的回跳操作
        if (steps === 3) {
          const data = this.GuideData.getThreeData()
          ;(this.$refs['detail'] as any).classhourDetail = data.classhourDetail
          ;(this.$refs['detail'] as any).handleTogglePre()
          setTimeout(() => {
            this.onDrivePrev()
          }, 400)
          return
        }

        // 第三阶段切换提交作业-第五步数据变更之后的回跳操作
        if (steps === 5) {
          const data = this.GuideData.getThreeData()

          // 第一屏作业列表数据还原
          ;(this.$refs['detail'] as any).classhourDetail = data.classhourDetail

          // 拉取作业内容数据
          ;(this.$refs['detail'] as any).handleMockToggleNext(data.homeworkSubmit)

          setTimeout(() => {
            this.onDrivePrev()
          }, 400)
          return
        }

        // 第三阶段切换提交作业-第七步：展示作业内容 - 修改批阅 的回跳操作
        if (steps === 7) {
          const data = this.GuideData.getWaitReviewedThreeData()
          ;(this.$refs['detail'] as any).classhourDetail = data.classhourDetail
          ;(this.$refs['detail'] as any).handleTogglePre()
          setTimeout(() => {
            this.onDrivePrev()
          }, 400)
          return
        }

        if (steps === 8) {
          const data = this.GuideData.getThreeData()
          ;(this.$refs['detail'] as any).handleMockToggleNext(data.homeworkContent)
          setTimeout(() => {
            this.onDrivePrev()
          }, 400)
          return
        }

        this.onDrivePrev()
      },
      onDestroyStarted: (el, step, options) => {
        const steps = options.state.activeIndex! + 1
        // 第三阶段结束操作
        if (steps === this.GuideData.dataStepThree.length) {
          driverObj.destroy()
          this.$router.replace({
            query: {},
            replace: true
          })
          this.GuideData.setGuideStatus(false)
          ;(this.$refs['detail'] as any).hidePop()
          // 拉起终页弹窗
          // 用户先获取笔山
          this.GuideData.onCheckReceivedBishan(this.courseId).then(() => {
            this.showFinalStepPop(true)
          })
          return
        } else {
          // 蒙层点击操作
          this.$confirmV2({
            desc: '确认要关闭指引吗？',
            onOk: () => {
              // 关闭课时详情弹窗
              ;(this.$refs['detail'] as any).hidePop()
              driverObj.destroy()
              this.$router.replace({
                query: {},
                replace: true
              })
              this.GuideData.setGuideStatus(false)
            }
          })
        }
      },
      onHighlightStarted: (el, step, options) => {
        const steps = options.state.activeIndex! + 1

        if (!el) return

        // 处理drive第三阶段拉取作业内容时出现白块
        if (steps === 4) {
          const originalScrollIntoView = el.scrollIntoView

          el.scrollIntoView = (option: any) => {
            option.inline = 'end'

            originalScrollIntoView.call(el, option)
          }
        }
      }
    }
    driverObj = driver(config)
    // 第三阶段第一步拉起弹窗
    const data = this.GuideData.getThreeData()
    ;(this.$refs['detail'] as any).showMockPop(data.classhourDetail)
    setTimeout(() => {
      driverObj.drive()
      this.GuideData.setStage(EnumGuideStep.Three)
    }, 400)
  }

  async handleClickClasshour(classhour: Classhour) {
    // 判读当前课程是否结课
    if (this.isLearnEnd) {
      this.$message.warn('课程已结课')
      return
    }
    // 需要先校验一个当前课时是否开放了
    if (classhour.publishStatus === 1) {
      ;(this.$refs['detail'] as any).showPop(classhour.classhourId)
    } else {
      this.$message.error('课时未发布')
    }
  }

  handleWriteDairy() {
    this.popLayout.open()
  }

  handleSuccess({ payload }: { payload: WaterfallMoment }) {
    this.popLayout.hide()

    // 将新的日记插入到瀑布流[发现]第一个位置处
    this.$store.$courseV2.CourseWaterfall.unshiftMomentItemToTab('find', payload)
  }

  handleClickWriteDairyOutside() {
    if (this.editor) {
      const { hasContent, hasImage, hasTitle } = this.editor.getFormStatus()

      if (hasContent || hasImage || hasTitle) {
        this.$confirmV2({
          desc: '你的日记还未提交',
          okText: '坚持离开',
          cancelText: '取消',
          clickToClose: false,
          onOk: () => {
            this.popLayout.hide()
          },
          onException: () => {
            this.popLayout.hide()
          }
        })
        return
      }
    }

    this.popLayout.hide()
  }

  handleShowCourseInfo() {
    if (this.hideCourseIntroductionTab) {
      return
    }

    this.showCourseInfoModal = true
  }

  handleCloseCourseInfo() {
    this.showCourseInfoModal = false
  }

  handleClickPrepare() {
    console.log('点击了开课前请准备')
    this.showGuidePop(true)
  }

  async handleClickReview() {
    console.log('你点击了review')
    if (!this.courseId) return

    if (!this.$store.$storeUser.UserInfo?.id) return

    const [, data] = await $service<StudyReviewResult>({
      method: 'GET',
      url: EnumApiCourse.CourseReview,
      data: {
        id: this.courseId
      },
      params: { id: this.courseId }
    })

    if (!data) return

    this.studyReview.showReview({
      ...data,
      courseId: this.courseId,
      nickname: this.$store.$storeUser.UserInfo.nickname
    })
  }

  handleClickBackToTop() {
    const el2 = document.getElementById('page-scroll-target-two')
    const { el1: el1Visible, el2: el2Visible } = elVisible

    if (!el2) return

    if (!el2Visible) {
      el2.scrollIntoView({
        behavior: 'smooth',
        block: 'start'
      })

      return
    }

    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    })
  }

  async mounted() {
    const el1 = document.getElementById('page-scroll-target-one')
    const el2 = document.getElementById('page-scroll-target-two')
    if (el1 && el2 && !this.ob) {
      this.ob = new IntersectionObserver(
        entities => {
          entities.forEach(entity => {
            if (entity.target === el1) {
              elVisible.el1 = entity.isIntersecting
              this.showBackToTop = entity.isIntersecting === false && entity.boundingClientRect.top < 0
            } else if (entity.target === el2) {
              elVisible.el2 = entity.isIntersecting
            }
          })
        },
        {
          threshold: [0, 1]
        }
      )

      this.ob.observe(el1)
      this.ob.observe(el2)
    }

    // 优先检查是否需要弹出引导弹窗
    if (this.$store.$courseV2.courseInfo?.viewPrepare === true) {
      this.showGuidePop(true)
    } else if (this.$route.query.openThreeStage) {
      // 接受stage标志进入第三阶段
      this.onStartThreeDrive()
    }

    const isban = await courseBan.isBan(this.productId)
    this.hideCourseIntroductionTab = lodash.isInteger(this.productId) && isban

    this.checkShowSummaryReview()
  }
  updated() {}
  // 重置为初始值
  beforeDestroy() {
    this.$store.$courseV2.reset()
  }
  destroyed() {
    driverObj && driverObj.destroy()

    if (this.ob) {
      this.ob.disconnect()
    }
  }
}
